import { ActionIcon, Tooltip } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import * as React from 'react';

import FieldText, { FieldTextProps } from '../FieldText';

import s from './FieldSearch.module.scss';

type FieldSearchProps = Omit<FieldTextProps, 'withClear' | 'leftSection'> & {
  onSearch?: () => void;
  isSearchDisabled?: boolean;
  disabledTooltip?: string;
};

const FieldSearch: React.FC<FieldSearchProps> = ({
  onSearch,
  isSearchDisabled = false,
  disabledTooltip = 'Введите поисковый запрос',
  ...props
}) => {
  const { type, inputMode, enterKeyHint, placeholder, ...rest } = props;

  const handleSearch = React.useCallback(() => {
    if (onSearch) {
      onSearch();
    }
  }, [onSearch]);

  const searchIcon = (
    <ActionIcon
      className={s.root__action}
      onClick={handleSearch}
      variant="transparent"
      disabled={isSearchDisabled}
      aria-label="Запустить поиск"
    >
      <IconSearch size={20} />
    </ActionIcon>
  );

  const leftSection = isSearchDisabled ? (
    <Tooltip label={disabledTooltip} withArrow position="bottom-start" withinPortal>
      <span className={s.root__action_wrapper}>{searchIcon}</span>
    </Tooltip>
  ) : (
    searchIcon
  );

  return (
    <FieldText
      leftSection={leftSection}
      placeholder={placeholder ?? 'Поиск'}
      type={type ?? 'search'}
      inputMode={inputMode ?? 'search'}
      enterKeyHint={enterKeyHint ?? 'search'}
      withClear
      {...rest}
    />
  );
};

export default React.memo(FieldSearch);
